import React from "react";
import PropTypes from "prop-types";

import { clx } from "../../../../../../utils/Helpers";
import { formatPayrollAmount } from "../utils/formatPayrollValue";

const formatCurrencyNumber = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

const EventPayrollSummaryMetrics = ({ items, labels, className }) => (
  <div className={clx("event-payroll-generate__summary", className)}>
    {items.map((item) => (
      <div
        key={item.key}
        className="event-payroll-generate__summary-item"
      >
        <span className="event-payroll-generate__summary-label text-label-lg">
          {item.label}
        </span>
        <span
          className={clx(
            "event-payroll-generate__summary-value",
            item.key === "netPay" &&
              "event-payroll-generate__summary-value--net-pay",
          )}
        >
          <span className="event-payroll-generate__summary-value-number">
            {item.isCurrency
              ? formatCurrencyNumber(item.value)
              : formatPayrollAmount(item.value, { signed: item.signed })}
          </span>
          {item.isCurrency ? ` ${labels.currency}` : null}
        </span>
      </div>
    ))}
  </div>
);

EventPayrollSummaryMetrics.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.number,
      signed: PropTypes.bool,
      isCurrency: PropTypes.bool,
    }),
  ).isRequired,
  labels: PropTypes.shape({
    currency: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
};

EventPayrollSummaryMetrics.defaultProps = {
  className: "",
};

export default EventPayrollSummaryMetrics;
